import { FriendListProps } from "./types"
import React from "react"
import { FriendListCore } from "./core"

const FriendList: React.FC<FriendListProps> = ({
  sections,
  swipeActionButtonConfigs,
  onItemClick,
  selecteds,
}) => {
  return (
    <FriendListCore
      sections={sections}
      swipeActionButtonConfigs={swipeActionButtonConfigs}
      onItemClick={onItemClick}
      selecteds={selecteds}
    ></FriendListCore>
  )
}

export default FriendList
